import type * as Yup from 'yup'

import { toArray } from './array'

export function transformValidationErrors(error: Yup.ValidationError) {
  return toArray(error.inner).reduce((errors, error) => {
    const [errorMessage] = toArray(error.errors)

    // Non-null assertion used on error.path because the path is always defined at this level.
    return { ...errors, [error.path!]: errorMessage }
  }, {})
}
